export const GET_ALL_NOTIFICATIONS = 'GET_ALL_NOTIFICATIONS'
export const ADD_NOTIFICATION_REAL_TIME = 'ADD_NOTIFICATION_REAL_TIME'
